import React from 'react';
import { Lock, PlayCircle } from 'lucide-react';
import { cn } from '../../lib/utils';
import type { PlayButtonProps } from './types';
import styles from './PlayButton.module.css';

export function PlayButton({ onClick, disabled, showLock, text, signatureColor }: PlayButtonProps) {
  const buttonStyle = disabled
    ? {}
    : {
        backgroundColor: signatureColor,
        boxShadow: `0 4px 12px ${signatureColor}33`,
        '--hover-bg': `${signatureColor}dd`,
        WebkitTextFillColor: 'white',
      };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        styles.button,
        disabled && styles.disabled,
        showLock && styles.locked
      )}
      style={buttonStyle as React.CSSProperties}
    >
      {showLock ? (
        <>
          <Lock className={styles.buttonIcon} />
          <span className={styles.buttonText}>{text}</span>
        </>
      ) : (
        <>
          <PlayCircle className={styles.buttonIcon} />
          <span className={styles.buttonText}>{text}</span>
        </>
      )}
    </button>
  );
}